/*
  Realizzandoo — Configuratore dello zainetto personalizzato.

  Stato: versione (Stampato/Ricamato) e colore scelgono la variante Shopify;
  animaletto, nome e colore del nome diventano proprieta' della riga.

  Anteprima dal vivo: sopra la prima foto della galleria si stende un canvas
  che ridisegna base del colore scelto + animaletto (stampato o ricamato) +
  nome nel font delle tovagliette. Le misure sono quelle dei mockup:
  coordinate in pixel delle basi da 4096 (vedi "layout" nel JSON).
  Su mobile la stessa scena, ritagliata sullo zaino, sta anche dentro la card.

  Il nome: lettere alte come "Tommaso" largo l'86% della patta; i nomi piu'
  lunghi si restringono fino a stare nella patta. Nessun limite di caratteri.
*/
(function () {
  'use strict';

  var root = document.querySelector('[data-rlz-zn]');
  if (!root) return;
  var dataEl = root.querySelector('[data-rlz-zn-data]');
  if (!dataEl) return;
  var D;
  try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var L = D.layout;
  var section = root.closest('[data-section-id]') || document;
  var state = {
    version: D.defaults.version,
    color: D.defaults.color,
    animal: D.defaults.animal,
    ncolor: D.defaults.ncolor,
    ncolorPicked: false,   // true solo dopo una scelta del cliente
    name: ''
  };

  function q(sel) { return root.querySelector(sel); }
  function qa(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  function track(ev, params) {
    try {
      var p = { event: ev };
      for (var k in params) p[k] = params[k];
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(p);
    } catch (e) { /* il tracking non deve mai rompere il configuratore */ }
  }

  // ---------- prezzi e variante ----------

  var moneyFmt = (function () {
    var locale = (document.documentElement.lang || 'it');
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }); }
    catch (e) { return { format: function (n) { return n.toFixed(2) + ' ' + currency; } }; }
  })();
  function money(cents) { return moneyFmt.format((cents || 0) / 100); }

  function optionOf(v, pos) { return pos === 1 ? v.option1 : pos === 2 ? v.option2 : v.option3; }
  function currentVariant() {
    for (var i = 0; i < D.variants.length; i++) {
      var v = D.variants[i];
      if (optionOf(v, D.posVersion) === state.version && optionOf(v, D.posColor) === state.color) return v;
    }
    return null;
  }

  function syncVariant() {
    var v = currentVariant();
    var priceEl = q('[data-rlz-zn-price]');
    if (v && priceEl) priceEl.textContent = money(v.price);
    var add = q('[data-rlz-zn-add]');
    if (add) add.disabled = !(v && v.available);
    if (!v) return;
    // La pagina aggiorna prezzo in alto, barra fissa e rate da questi due eventi.
    // featured_image nullo: la galleria non deve saltare via dall'anteprima.
    document.dispatchEvent(new CustomEvent('rlz:variant-change', {
      detail: { variant: { id: v.id, price: v.price, compare_at_price: v.compare_at_price, available: v.available, featured_image: null } }
    }));
    document.dispatchEvent(new CustomEvent('rlz:composizione-change', { detail: { priceCents: v.price } }));
  }

  // ---------- immagini e font ----------

  var cache = {};
  function loadImg(src) {
    if (cache[src]) return cache[src];
    cache[src] = new Promise(function (resolve, reject) {
      var im = new Image();
      im.decoding = 'async';
      im.onload = function () { resolve(im); };
      im.onerror = reject;
      im.src = src;
    });
    return cache[src];
  }
  var fontReady = (document.fonts && document.fonts.load)
    ? document.fonts.load('100px RlzZnName').catch(function () {})
    : Promise.resolve();

  // ---------- disegno ----------

  // Canvas sopra la prima foto della galleria: stessa inquadratura delle basi.
  var bigCanvas = null;
  var slide0 = section.querySelector('.rlz-mp__slide[data-slide="0"]');
  if (slide0) {
    bigCanvas = document.createElement('canvas');
    bigCanvas.className = 'rlz-zn-live';
    bigCanvas.width = 1400;
    bigCanvas.height = 1400;
    bigCanvas.setAttribute('aria-hidden', 'true');
    slide0.appendChild(bigCanvas);
  }
  // La miniatura della prima foto segue l'anteprima: senza, con lo zaino blu
  // la foto grande era blu e la sua miniatura restava rosa.
  var thumbCanvas = null;
  var thumb0 = section.querySelector('.rlz-mp__thumb[data-index="0"]');
  if (thumb0 && bigCanvas) {
    thumbCanvas = document.createElement('canvas');
    thumbCanvas.className = 'rlz-zn-thumb-live';
    thumbCanvas.width = 160;
    thumbCanvas.height = 160;
    thumbCanvas.setAttribute('aria-hidden', 'true');
    thumb0.classList.add('rlz-zn-has-live');
    thumb0.appendChild(thumbCanvas);
  }
  var miniCanvas = q('[data-rlz-zn-mini]');
  var miniWrap = miniCanvas ? miniCanvas.parentElement : null;


  function nameText() {
    var t = state.name.replace(/\s+/g, ' ').trim();
    return t || D.defaults.example;
  }

  function fitName(ctx, text, s) {
    // dimensione: lettera maiuscola alta nameCap, poi si restringe se supera larghezza o altezza
    var size = 100;
    ctx.font = size + 'px RlzZnName';
    var capH = ctx.measureText('H').actualBoundingBoxAscent || 70;
    size = size * (L.nameCap * s) / capH;
    for (var i = 0; i < 3; i++) {
      ctx.font = size + 'px RlzZnName';
      var m = ctx.measureText(text);
      var w = (m.actualBoundingBoxLeft || 0) + (m.actualBoundingBoxRight || m.width);
      var h = (m.actualBoundingBoxAscent || 0) + (m.actualBoundingBoxDescent || 0);
      var k = Math.min(1, (L.nameMaxW * s) / Math.max(w, 1), (L.nameMaxH * s) / Math.max(h, 1));
      if (k > 0.995) break;
      size *= k;
    }
    ctx.font = size + 'px RlzZnName';
    return ctx.measureText(text);
  }

  function drawScene(canvas, crop, base, animal) {
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var W = canvas.width, H = canvas.height;
    var cx0 = crop ? crop[0] : 0, cy0 = crop ? crop[1] : 0;
    var cw = crop ? crop[2] - crop[0] : L.size;
    var s = W / cw;                          // pixel canvas per pixel-base 4096
    var ox = -cx0 * s, oy = -cy0 * s;
    ctx.clearRect(0, 0, W, H);
    ctx.drawImage(base, ox, oy, L.size * s, L.size * s);
    // animaletto: misura sua (10-12 cm sul lato lungo), appoggiato sulla linea di base comune
    var cm = (D.sizes && D.sizes[state.animal]) || 10;
    var k = (L.animalLong * (cm / 10) * s) / Math.max(animal.naturalWidth, animal.naturalHeight);
    var aw = animal.naturalWidth * k, ah = animal.naturalHeight * k;
    var ay = L.animalBase ? oy + L.animalBase * s - ah : oy + L.animalCy * s - ah / 2;
    ctx.drawImage(animal, ox + L.animalCx * s - aw / 2, ay, aw, ah);
    // nome
    var text = nameText();
    ctx.save();
    ctx.textAlign = 'left';
    ctx.textBaseline = 'alphabetic';
    var m = fitName(ctx, text, s);
    var left = m.actualBoundingBoxLeft || 0, right = m.actualBoundingBoxRight || m.width;
    var asc = m.actualBoundingBoxAscent || 0, desc = m.actualBoundingBoxDescent || 0;
    var x = ox + L.nameCx * s - (right - left) / 2;
    var y = oy + L.nameCy * s - (desc - asc) / 2;
    ctx.fillStyle = D.nameColors[state.ncolor] ? D.nameColors[state.ncolor].hex : '#fff';
    if (state.version === 'Ricamato') {
      // filo in rilievo: ombra corta sul tessuto e una luce sottile sul bordo alto
      ctx.shadowColor = 'rgba(0,0,0,0.35)';
      ctx.shadowBlur = Math.max(1, 6 * s);
      ctx.shadowOffsetX = 2 * s;
      ctx.shadowOffsetY = 3 * s;
      ctx.fillText(text, x, y);
      ctx.shadowColor = 'transparent';
      ctx.globalAlpha = 0.25;
      ctx.fillStyle = '#ffffff';
      ctx.fillText(text, x - 1.5 * s, y - 2 * s);
      ctx.globalAlpha = 1;
      ctx.fillStyle = D.nameColors[state.ncolor] ? D.nameColors[state.ncolor].hex : '#fff';
      ctx.fillText(text, x, y);
    } else {
      ctx.fillText(text, x, y);
    }
    ctx.restore();
  }

  var drawToken = 0;
  function render() {
    var token = ++drawToken;
    var col = D.colors[state.color];
    var an = D.animals[state.animal];
    if (!col || !an) return;
    var animalSrc = state.version === 'Ricamato' ? an.r : an.s;
    Promise.all([loadImg(col.base), loadImg(animalSrc), fontReady]).then(function (r) {
      if (token !== drawToken) return;       // e' arrivata una scelta piu' recente
      drawScene(bigCanvas, null, r[0], r[1]);
      if (thumbCanvas) {
        var tctx = thumbCanvas.getContext('2d');
        tctx.clearRect(0, 0, thumbCanvas.width, thumbCanvas.height);
        tctx.drawImage(bigCanvas, 0, 0, thumbCanvas.width, thumbCanvas.height);
      }
      if (miniCanvas && miniWrap && getComputedStyle(miniWrap).display !== 'none') drawScene(miniCanvas, L.miniCrop, r[0], r[1]);
      if (bigCanvas) bigCanvas.classList.add('is-ready');
    }).catch(function () { /* senza anteprima resta la foto: la pagina funziona lo stesso */ });
  }

  function showPreviewSlide() {
    if (!slide0 || slide0.classList.contains('is-active')) return;
    section.querySelectorAll('.rlz-mp__slide').forEach(function (s) { s.classList.remove('is-active'); });
    section.querySelectorAll('.rlz-mp__thumb').forEach(function (t) { t.classList.remove('is-active'); });
    slide0.classList.add('is-active');
    var t0 = section.querySelector('.rlz-mp__thumb[data-index="0"]');
    if (t0) t0.classList.add('is-active');
  }

  // ---------- interfaccia ----------

  function select(attr, value) {
    qa('[' + attr + ']').forEach(function (b) {
      var on = b.getAttribute(attr) === value;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }

  function syncNameColors() {
    var hide = (D.colors[state.color] && D.colors[state.color].hide) || [];
    qa('[data-rlz-zn-ncolor]').forEach(function (b) {
      b.hidden = hide.indexOf(b.getAttribute('data-rlz-zn-ncolor')) !== -1;
    });
    // Finche' il cliente non sceglie, il nome segue il colore abbinato a ogni zaino;
    // una scelta sua resta, salvo che su quello zaino si legga male (allora torna l'abbinato).
    if (!state.ncolorPicked || hide.indexOf(state.ncolor) !== -1) {
      state.ncolor = D.colors[state.color].defaultName;
      select('data-rlz-zn-ncolor', state.ncolor);
    }
    var lab = q('[data-rlz-zn-ncolor-label]');
    if (lab && D.nameColors[state.ncolor]) lab.textContent = D.nameColors[state.ncolor].label;
  }

  function update(opts) {
    var colLab = q('[data-rlz-zn-color-label]');
    if (colLab && D.colors[state.color]) colLab.textContent = D.colors[state.color].label;
    var anLab = q('[data-rlz-zn-animal-label]');
    if (anLab && D.animals[state.animal]) anLab.textContent = D.animals[state.animal].label;
    syncNameColors();
    if (opts && opts.variant) syncVariant();
    if (!(opts && opts.silent)) showPreviewSlide();
    render();
  }

  qa('[data-rlz-zn-version]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.version = b.getAttribute('data-rlz-zn-version');
      select('data-rlz-zn-version', state.version);
      update({ variant: true });
    });
  });
  qa('[data-rlz-zn-color]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.color = b.getAttribute('data-rlz-zn-color');
      select('data-rlz-zn-color', state.color);
      update({ variant: true });
    });
  });
  qa('[data-rlz-zn-animal]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.animal = b.getAttribute('data-rlz-zn-animal');
      select('data-rlz-zn-animal', state.animal);
      update();
    });
  });
  qa('[data-rlz-zn-ncolor]').forEach(function (b) {
    b.addEventListener('click', function () {
      state.ncolor = b.getAttribute('data-rlz-zn-ncolor');
      state.ncolorPicked = true;
      select('data-rlz-zn-ncolor', state.ncolor);
      update();
    });
  });
  var nameInput = q('[data-rlz-zn-name]');
  if (nameInput) {
    nameInput.addEventListener('input', function () {
      state.name = nameInput.value;
      nascondiErrore();
      update();
    });
  }

  // Dalla sezione "Stampato o ricamato?" piu' in basso: sceglie la versione e torna qui.
  document.addEventListener('rlz:zn-choose-version', function (e) {
    var v = e.detail && e.detail.version;
    if (v !== 'Stampato' && v !== 'Ricamato') return;
    state.version = v;
    select('data-rlz-zn-version', v);
    update({ variant: true });
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // ---------- errori ----------

  var errEl = q('[data-rlz-zn-error]');
  function mostraErrore(msg) {
    if (!errEl) return;
    errEl.textContent = msg;
    errEl.hidden = false;
  }
  function nascondiErrore() { if (errEl) errEl.hidden = true; }

  // ---------- carrello ----------

  var add = q('[data-rlz-zn-add]');
  if (add) {
    add.addEventListener('click', function () {
      nascondiErrore();
      var nome = state.name.replace(/\s+/g, ' ').trim();
      if (!nome) {
        mostraErrore(D.labels.nameRequired);
        if (nameInput) {
          nameInput.focus({ preventScroll: true });
          nameInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }
      var v = currentVariant();
      if (!v || !v.available) { mostraErrore(D.labels.unavailable); return; }
      // Valori in italiano: sono le istruzioni per il laboratorio, qualunque sia la lingua del cliente.
      var props = {
        'Nome': nome,
        'Colore nome': state.ncolor,
        'Animaletto': D.itAnimals[state.animal] || state.animal
      };
      add.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) { mostraErrore((res.body && res.body.description) || D.labels.generic); return; }
          document.dispatchEvent(new CustomEvent('rlz:cart-updated'));
          track('rlz_zn_atc', {
            value: v.price / 100, version: state.version, color: state.color, animal: state.animal,
            currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
          });
          apriCarrello();
        })
        .catch(function () { mostraErrore(D.labels.generic); })
        .finally(function () { add.disabled = false; });
    });
  }

  // Stessa apertura del carrello laterale del configuratore del collare.
  function apriCarrello() {
    var drawer = document.querySelector('cart-drawer, [data-rlz-cart-drawer]');
    var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (!drawer) { window.location.href = rootPath + 'cart'; return; }
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('.cart-count, .cart-item-count, [data-cart-count], #cart-icon-bubble .cart-count-bubble span:first-child').forEach(function (el) {
        el.textContent = cart.item_count;
      });
    }).catch(function () {});
    fetch(rootPath + '?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var dom = new DOMParser().parseFromString(html, 'text/html');
        var fresh = dom.querySelector('cart-drawer');
        if (fresh) drawer.innerHTML = fresh.innerHTML;
        drawer.classList.remove('is-empty');
        drawer.classList.add('animate', 'active');
        document.body.classList.add('overflow-hidden');
      })
      .catch(function () { drawer.classList.add('animate', 'active'); });
  }

  // ---------- "Ordina entro ... per riceverlo prima di Natale" ----------
  // Stesso calendario di rlz-estimated-delivery.js: niente sabato, domenica e festivi.

  var FIXED_HOLIDAYS = ['01-01', '01-06', '04-25', '05-01', '06-02', '08-15', '11-01', '12-08', '12-25', '12-26'];
  function isBusinessDay(d) {
    var day = d.getDay();
    if (day === 0 || day === 6) return false;
    var mm = String(d.getMonth() + 1).padStart(2, '0');
    var dd = String(d.getDate()).padStart(2, '0');
    return FIXED_HOLIDAYS.indexOf(mm + '-' + dd) === -1;
  }
  function addBusinessDays(start, n) {
    var d = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    var added = 0;
    while (added < n) { d.setDate(d.getDate() + 1); if (isBusinessDay(d)) added++; }
    return d;
  }
  function arrivo(orderDay) { return addBusinessDays(addBusinessDays(orderDay, D.prod[1]), D.ship[1]); }

  function xmasLine() {
    var el = q('[data-rlz-zn-xmas]');
    if (!el || !D.xmasTarget || !D.labels.xmas) return;
    var p = D.xmasTarget.split('-');
    var target = new Date(+p[0], +p[1] - 1, +p[2]);
    var today = new Date();
    today = new Date(today.getFullYear(), today.getMonth(), today.getDate());
    if (arrivo(today) > target) { el.hidden = true; return; }
    var last = new Date(today);
    for (var i = 0; i < 120; i++) {
      var next = new Date(last.getFullYear(), last.getMonth(), last.getDate() + 1);
      if (arrivo(next) > target) break;
      last = next;
    }
    var locale = (document.documentElement.lang || 'it').toLowerCase().split('-')[0];
    var txt;
    try { txt = new Intl.DateTimeFormat(locale, { weekday: 'long', day: 'numeric', month: 'long' }).format(last); }
    catch (e) { txt = last.toLocaleDateString(); }
    el.textContent = D.labels.xmas.replace('{date}', txt);
    el.hidden = false;
  }

  // Prezzi delle tessere e del pulsante nello stesso formato che il tema usa
  // dopo ogni scelta (Intl): niente "€47,99" accanto a "47,99 €".
  function formatPrices() {
    qa('[data-rlz-zn-version]').forEach(function (b) {
      var ver = b.getAttribute('data-rlz-zn-version');
      var min = null;
      D.variants.forEach(function (v) { if (optionOf(v, D.posVersion) === ver && (min === null || v.price < min)) min = v.price; });
      var el = b.querySelector('.rlz-zn__version-price');
      if (el && min !== null) el.textContent = money(min);
    });
    var v = currentVariant();
    var priceEl = q('[data-rlz-zn-price]');
    if (v && priceEl) priceEl.textContent = money(v.price);
  }

  // ---------- avvio ----------

  // Dagli annunci di catalogo si arriva con ?variant=: si parte da quella versione e colore.
  var fromLink = false;
  if (D.initialVariant) {
    D.variants.forEach(function (v) {
      if (v.id !== D.initialVariant) return;
      var ver = optionOf(v, D.posVersion), col = optionOf(v, D.posColor);
      if (ver && col && D.colors[col]) {
        state.version = ver;
        state.color = col;
        select('data-rlz-zn-version', ver);
        select('data-rlz-zn-color', col);
        fromLink = true;
      }
    });
  }
  formatPrices();
  update({ variant: fromLink, silent: true });
  // Il prezzo in alto si aggiorna ascoltando rlz:variant-change, ma la pagina comincia ad
  // ascoltare solo a DOMContentLoaded: arrivando da un link con la variante, si riavvisa dopo.
  if (fromLink) {
    var resent = false;
    var resend = function () { if (resent) return; resent = true; setTimeout(syncVariant, 0); };
    if (document.readyState === 'complete') resend();
    else {
      document.addEventListener('DOMContentLoaded', resend);
      window.addEventListener('load', resend);
    }
  }
  xmasLine();
  // il canvas della mini anteprima esiste solo quando e' visibile (mobile): ridisegna al cambio di larghezza
  window.addEventListener('resize', function () { render(); }, { passive: true });
})();
